import { DisplayValue } from "../details/tabs/types";
import { placeholder } from "./defaults";
import { isMissingDisplayValue } from "./string-manipulation";

export const formathumanWrittenStyleList = (values: Array<string>): string => {
  if (values.length === 1) return values[0];
  if (values.length === 2) return `${values[0]} and ${values[1]}`;

  return `${values.slice(0, -1).join(", ")} and ${values[values.length - 1]}`;
};

export function getArrayDisplayValues(
  values?: Array<DisplayValue>,
  type?: "singleLine" | "multipleLines" | "joinedSentences",
): string {
  const displayValues = values
    ?.filter((value) => !isMissingDisplayValue(value))
    .map(String);

  if (!displayValues?.length) return placeholder;
  return type === "singleLine"
    ? displayValues.join(", ")
    : type === "joinedSentences"
      ? displayValues?.join(" ")
      : displayValues.join("\n");
}

export const normaliseToStringArray = (
  value: string | Array<string> | null | undefined,
): Array<string> => {
  if (Array.isArray(value)) return value;
  if (typeof value === "string") return [value];
  return [];
};
